module.exports = __webpack_public_path__ + "9ed4925ed7b52f1be30dc8a22698fc6d.gif";